// extracted by mini-css-extract-plugin
export default {"imageWrapper":"AH-z","twoColumnImage":"BH-z"};